import { z } from 'zod'

/** What happened to a test-mode email (mirrors Prisma `MailDeliveryStatus`). */
export const MAIL_DELIVERY_STATUSES = ['captured', 'delivered', 'delivery_failed'] as const

export const mailDeliveryStatusSchema = z.enum(MAIL_DELIVERY_STATUSES)

export type MailDeliveryStatus = z.infer<typeof mailDeliveryStatusSchema>

export const PRISMA_MAIL_DELIVERY_STATUSES = ['CAPTURED', 'DELIVERED', 'DELIVERY_FAILED'] as const

export type PrismaMailDeliveryStatus = (typeof PRISMA_MAIL_DELIVERY_STATUSES)[number]

export const MAIL_DELIVERY_STATUS_FROM_PRISMA = {
  CAPTURED: 'captured',
  DELIVERED: 'delivered',
  DELIVERY_FAILED: 'delivery_failed',
} as const satisfies Record<PrismaMailDeliveryStatus, MailDeliveryStatus>

export const MAIL_DELIVERY_STATUS_TO_PRISMA = {
  captured: 'CAPTURED',
  delivered: 'DELIVERED',
  delivery_failed: 'DELIVERY_FAILED',
} as const satisfies Record<MailDeliveryStatus, PrismaMailDeliveryStatus>
